import React, { Component } from 'react'
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';

import PlayerAbilityCard from '../cards/PlayerAbilityCard';
import { bolt, brain, bullsEyeArrow, handRock, running, shield, star } from "../Icon";

class PlayerAbilitySection extends Component {

    static propTypes = {
        cards: PropTypes.arrayOf([

            PropTypes.objectOf({

                title: PropTypes.string,
                icon: PropTypes.element,
                columns: PropTypes.number,
                items: PropTypes.arrayOf([

                    PropTypes.objectOf({
                        title: PropTypes.string,
                        description: PropTypes.string,
                        value: PropTypes.number,
                        attachments: PropTypes.arrayOf([

                            PropTypes.objectOf({

                                name: PropTypes.string,
                                type: PropTypes.string
                            })

                        ])

                    })

                ])

            })

        ])
    }

    render() {
        const { cards, onAttachmentClick } = this.props;

        return (
            <div className="player-ability-section">
                <Row className="gutters-12">
                    {cards.map((playerAbility, index) => {
                        const { columns = 1 } = playerAbility;
                        return (
                            <Col
                                key={index}
                                lg={this.calcCardColumnsInViewport('lg', columns)}
                                md={this.calcCardColumnsInViewport('md', columns)}
                            >
                                <PlayerAbilityCard
                                    columns={columns}
                                    title={playerAbility.title}
                                    icon={playerAbility.icon}
                                    items={playerAbility.items}
                                    onAttachmentClick={onAttachmentClick}
                                />
                            </Col>
                        )
                    })}
                </Row>
            </div>
        )
    }

    /**
     * Number of col in each viewport
     */
    columnsInViewport = {
        lg: 3,
        md: 2,
    }

    /**
     * Calculate how each card will take from the screen based on the view port and how much columns it has
     */
    calcCardColumnsInViewport = (viewport, columns) => (12 / this.columnsInViewport[viewport] * columns)

    static defaultProps = {
        cards: [],
        onAttachmentClick: () => console.log('Attachment Click')
    }
}

export default PlayerAbilitySection

/**
 * Props Sample
 */

// const items = [
//     { title: 'Overall', description: 'A good passer Playing in forward', value: 72, attachments: [{ name: 'Adel', type: 'pdf' }] },
//     { title: 'Overall', description: 'A good passer Playing in forward', value: 72, attachments: [] },
//     { title: 'Overall', description: 'A good passer Playing in forward', value: 72, attachments: [] },
//     { title: 'Overall', description: 'A good passer Playing in forward', value: 72, attachments: [] },
//     { title: 'Overall', description: 'A good passer Playing in forward', value: 72, attachments: [] },
//     { title: 'Overall', description: 'A good passer Playing in forward', value: 72, attachments: [] },
// ];

// const cards = [
//     { title: 'Attacking', icon: bullsEyeArrow, items: [...items, ...items], columns: 2 },
//     { title: 'Skills', icon: handRock, items: items },
//     { title: 'Movement', icon: running, items: items },
//     { title: 'Power', icon: bolt, items: items },
//     { title: 'bolt', icon: brain, items: items },
//     { title: 'Defence', icon: shield, items: items },
//     { title: 'Goal Keeping', icon: bolt, items: items },
//     { title: 'Specialities', icon: star, items: items },
// ]